import React,{Component} from "react";
//import "../../node_modules/react-pro-sidebar/dist/css/styles.css";
import "./header/Header.css";
import "../scss/general.css";
import logo from "./images/loading.gif";
import Moment from "moment";
import ModalLogin from './ModalLogin';
import Mymodal from  './modal';
import Cookies from "universal-cookie";
import config from '../config';
const cookies = new Cookies();
const axios = require("axios");
export default class Daily_attendance extends Component {
    constructor(props) {
        super(props);
        this.state = {
        input:{},
        myitems: [],
        mylocation: [],
        statustext:[],
        isLoaded: false,
        islocation: false,
        ErrMsg:<img src={logo} alt="Error"/>,
        ErrMsg2:"",
        today: new Date(),
        cValue:new Date(),
        DivClass: "ErrDiv",
        minDate:'',
        maxDate:'',
        leaveclass: "tdm",
        lcode:'',
        leftclass:"mtdleft"
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLoadData=this.handleLoadData.bind(this);
        this.handleSelectChange=this.handleSelectChange.bind(this);
        this.handleClear=this.handleClear.bind(this);
    }
    cur=(num)=> {
        if(num > 0)
    
            return num.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        else
            return "-"
    }
    handleClear(){
        this.setState({ErrMsg:""});
    }
    
    handleSelectChange=(e)=>{
        this.setState({lcode:e.target.value});
    }
    handleChange=(e)=>{
        let cString=e.target.value;
        this.setState({today:cString,cValue:e.target.value});

    }
    handleLoadData(){
        document.body.style.cursor="wait";
        let input=this.state.input;
        input["l_code"]=this.state.lcode;
        input["cDate"]=Moment(this.state.today).format("DD/MM/YYYY");
        console.log(input);
        this.setState({input,isLoaded:true,islocation:true,ErrMsg:<img src={logo} alt="Error"/>,myitems:[]});
        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/get_daily_attendance/',
            data:input,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
            if(response.data === 0)
            {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            }
            else
            {
                document.body.style.cursor="default";
                this.setState({
                isLoaded: true,
                ErrMsg:"",
                myitems: response.data
                })
            };
        })
        .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
        });  
    }

    componentDidMount()
    {
        if(cookies.get("LoginID"))
        {  
            let cmonth=this.state.cMonth;
            let cyear=this.state.cYear;
            if(cmonth >= 7 && cmonth <= 12)
                this.setState({minDate:cyear +"-07",maxDate: (cyear+1)+"-06"});
            else
                this.setState({minDate:(cyear-1) +"-07",maxDate: cyear+"-06"});
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/get_location/'+cookies.get("LoginID"),
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                console.log(response.data);
                if(response.data === 2)
                {
                    document.body.style.cursor="default";
                    this.setState({ErrMsg:"Sorry, you are not authorised to use this feature. Only authorised perons have access this feature",islocation:false,isLoaded:false});
                }
                else
                {
                    document.body.style.cursor="default";
                    this.setState({
                    islocation: true,
                    isLoaded:true,
                    ErrMsg:"",
                    mylocation: response.data,
                    lcode:response.data[0]["l_code"]
                    })
                };
            })
            .catch((response)=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            });  
        }
        else
        {
            this.setState({ErrMsg:<ModalLogin mTitle={config.gvr.ErrMsgs.TitleNotLoggedin} mBody={config.gvr.ErrMsgs.MsgNotLoggedin}/>});
        }
    }
    render()
    {
        let isLoaded = this.state.isLoaded;
        let islocation = this.state.islocation;
        let items = this.state.myitems;   
        let litems = this.state.mylocation;   
        if (!isLoaded && !islocation) 
        {
            return(
            <div className="container1">
                <div className="center">
                    {this.state.ErrMsg}
                </div>
            </div>
            );
        } 
        else if(isLoaded && islocation)
        {
            return(
            <div className="container1">
            <div width="100%" align="center" >    
            <div className="inner-profile" >
            <span className="box-title">Attendance</span>
            <br></br><br></br>  
            <div style={{width:"100%",textAlign:"left"}} >
            <label style={{paddingLeft:2,width:"70px"}}>Location <font style={{color:"red"}}>*</font></label>
            <select id="location" name="location" style={{height:25,width:150,borderRadius:0}} onChange={this.handleSelectChange} >
                {litems.map((result,i)=>{
                return(
                    <option value={result.l_code} key={i}  >{result.location}</option>
                );
                })}
            </select>
            <p style={{width:5}}/>
            <label style={{paddingLeft:2,width:"70px"}}>Date <font style={{color:"red"}}>*</font></label>

            <input type="date" id="start" name="start" value={this.state.today} onChange={this.handleChange} style={{width:150,height:25}}   />
            <button type="submit" style={{background: "linear-gradient(to bottom , #ffffff 0%, white 100%)",marginLeft:15}} onClick={this.handleLoadData}>Submit </button>
            </div>
            <br></br>
            <table style={{width:"100%",paddingLeft:"1%",paddingTop:"10px"}}>
            <thead>
                <tr className="tr">
                    <th className="th" scope="col">Employee Name</th>
                    <th className="th" scope="col">Designation</th>
                    <th className="th" scope="col">Date</th>
                    <th className="th" scope="col">Time in</th>
                    <th className="th" scope="col">Time out</th>
                    <th className="th" scope="col">Status</th>
                </tr>
            </thead>
            <tbody>
            {
                items.map((result ,i) => {
                    let leavedays='';
                    let attclass="tdm";
                    let leftclass="mtdleft";
                    if(result.leaveday == 0.5)
                    {
                        leavedays='half day '+result.leavetype;
                        attclass="tdmleaves";
                        leftclass="mtdleft22";
                    }
                    else if (result.leaveday == 1)
                    {
                        leavedays='1.0 day '+ result.leavetype;
                        attclass="tdmleaves";
                        leftclass="mtdleft22";
                    }
                    if(result.timein==null && result.timeout==null && result.leaveday==null )
                    {
                        leavedays='Absent  ';
                        attclass="tdmabsent";
                    }
        
                    return(
                        <tr className="trc" key={i}>
                            <td className={leftclass}>{result.name}</td>
                            <td className={leftclass}>{result.desig}</td>
                            <td className={attclass}>{Moment(result.att_date).format("DD/MM/YYYY")}</td>
                            <td className={attclass}>{result.timein}</td>
                            <td className={attclass}>{result.timeout}</td>
                            <td className={leftclass}>{leavedays}</td>
                        </tr>
                    );    
                })}

                </tbody>
                </table>
            </div>
            </div>
        </div>
        );
    }
}}
